import { Box, Stack, TextField } from "@mui/material";
import React from "react";

export default function CompteForm(props) {

    return(
        <Box>
            <TextField fullWidth required sx={{minWidth:'200px'}} label="Libellé" value={props.compte.libelle} onChange={(e)=>props.setCompte(e.target.value, 'libelle')}/>
            <Stack direction='row' spacing={2} sx={{paddingBlock:'10px'}}>
                <TextField fullWidth required sx={{minWidth:'150px'}} label={"N° compte"}
                value={props.compte.num_compte} onChange={(e)=>props.setCompte(e.target.value, 'num_compte')}/>
                <TextField type="number" fullWidth sx={{minWidth:'70px'}} label={"Solde"} 
                onFocus={()=>{if(props.compte.solde===0) props.setCompte('', 'solde')}} value={props.compte.solde} 
                onChange={(e)=>{if(/^-?\d*([,.]\d{1,2})?$/.test(e.target.value)){props.setCompte(e.target.value===''? '':Number(parseFloat(e.target.value).toFixed(2)), 'solde')}}}/>
            </Stack>
        </Box>
    )
}